import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { getAllWorkspaceTeams, ITeam } from 'wisestep-api';

import TeamsList from '../../components/TeamsList';

export interface IWorkspaceTeamsTable {
  jobIds: string[];
  onAssign: () => void;
}

const TeamsListsTable = ({ jobIds, onAssign }: IWorkspaceTeamsTable) => {
  const [workspaceTeamsResponse, setWorkspaceTeamsResponse] = useState<ITeam[]>([]);

  useEffect(() => {
    const getTeamsAndRecruiters = async () => {
      const workspaceTeamsResponse = await getAllWorkspaceTeams();
      if (workspaceTeamsResponse.data) {
        setWorkspaceTeamsResponse(workspaceTeamsResponse.data);
      }
    };
    getTeamsAndRecruiters();
  }, [jobIds]);

  return (
    <Grid container p={2} mb={5}>
      <TeamsList onAssign={onAssign} teamsData={workspaceTeamsResponse} jobIds={jobIds} />
    </Grid>
  );
};

export default TeamsListsTable;
